import { MapPin, Phone, Mail, Instagram, Facebook, Music2, MessageCircle } from "lucide-react";
import { waHref } from "@/lib/wa";

const NAV = [
  { label: "Beranda", href: "#beranda" },
  { label: "Tentang Kami", href: "#tentang" },
  { label: "Perumahan", href: "#perumahan" },
  { label: "Tipe Rumah", href: "#tipe-rumah" },
  { label: "Fasilitas", href: "#fasilitas" },
  { label: "Lokasi", href: "#lokasi" },
  { label: "Galeri", href: "#galeri" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontak", href: "#kontak" },
];

export default function Footer({ content }) {
  const c = content.contact;
  const contacts = [
    { icon: MapPin, label: c.address, testId: "footer-address" },
    { icon: MessageCircle, label: content.whatsapp, testId: "footer-whatsapp" },
    { icon: Phone, label: c.phone, testId: "footer-phone" },
    { icon: Mail, label: c.email, testId: "footer-email" },
  ];
  const socials = [
    { icon: Instagram, label: c.instagram, testId: "footer-instagram" },
    { icon: Facebook, label: c.facebook, testId: "footer-facebook" },
    { icon: Music2, label: c.tiktok, testId: "footer-tiktok" },
  ];

  return (
    <footer className="bg-navy-texture pb-28 pt-16 text-white sm:pb-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/assets/logo.jpeg" alt="Logo PT. Cahaya Sakofa Mulia" className="h-12 w-12 rounded-xl object-cover" />
              <div>
                <p className="font-display text-lg font-bold leading-tight">PT. CAHAYA SAKOFA MULIA</p>
                <p className="text-xs uppercase tracking-[0.15em] text-slate-400">Developer Perumahan Type 36 Cluster</p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              Menghadirkan hunian Type 36 dengan konsep cluster yang nyaman dan ideal bagi keluarga.
            </p>
          </div>
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Navigasi</h3>
            <ul className="mt-5 grid grid-cols-2 gap-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-slate-300 transition-colors duration-200 hover:text-white">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Kontak</h3>
            <ul className="mt-5 space-y-3">
              {contacts.map((cItem, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-slate-300" data-testid={cItem.testId}>
                  <cItem.icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-sky" />
                  {cItem.label}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex gap-3">
              {socials.map((s, i) => (
                <span key={i} title={s.label} data-testid={s.testId} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-colors hover:border-brand-sky hover:text-white">
                  <s.icon className="h-4 w-4" />
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-14 border-t border-white/10 pt-7 text-center">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © 2026 PT. CAHAYA SAKOFA MULIA. All Rights Reserved.
          </p>
          <p className="mt-2 text-[10px] text-slate-600">
            Musik latar: "Wholesome" — Kevin MacLeod (incompetech.com), Lisensi CC BY 4.0
          </p>
        </div>
      </div>
    </footer>
  );
}
